var exports = {
  "kL": "container__DM2ICH",
  "R8": "copyContent__owKUhU",
  "cL": "copyButton__Gu4mM1",
  "a6": "assistive__Yt01vz",
  "wx": "header__vUp4TA",
  "a4": "immersive__wT2abX",
  "aY": "code__71epnn",
  "Hy": "codeContainer__dREmJs",
  "dD": "copyContainer__fuDJL9",
  "Ln": "languageName__90hoNL",
  "Mp": "codeWrap__vBkB2U",
};

module.exports = exports;
